import React from "react";
import get from "lodash/get";
import { object } from "prop-types";
import { Text } from "@quintype/arrow";
import useUrl from "../../../hook/useUrl";
import { Link } from "@quintype/components";
import "./also-read.m.css";

const AlsoRead = ({ story, element }) => {
  const [_,currentUrlSlug]=useUrl();
  const linkedStoryId = get(element, ["metadata", "linked-story", "id"], "");
  const linkedStory = get(story, ["linked-stories", linkedStoryId], {});
  const linkedStorySlug = get(story, ["linked-stories", linkedStoryId, "slug"], "");
  const linkedStorySections=get(linkedStory, ["sections"], {});
  let pageSlug = "";
  if (currentUrlSlug.includes(linkedStorySections[0]["domain-slug"])) {
    pageSlug = `/${currentUrlSlug}`;
  }else if(!currentUrlSlug.includes(linkedStorySections[0]["domain-slug"])){
    linkedStorySections.map((items) => {
      switch (items["domain-slug"]) {
        case "vaasa":
          pageSlug = "/vaasalehti";
          break;
        case "epari":
          pageSlug = "/epari";
          break;
        default:
          pageSlug = "";
      }
    return pageSlug;
  });
  }
  return (
    <Link href={`${pageSlug}/${linkedStorySlug}`} styleName="wrapper">
      <div styleName="content">
      <Text element={element} render={linkedStory.headline}/>
      </div>
    </Link>
  );
};

AlsoRead.propTypes = {
  story: object,
  element: object
};

export default AlsoRead;
